import $http from '../http'

// 获取问卷列表
export const getTask = data => {
    return $http.get(`/api/v1/admin/task/list`, data)
}